module.exports = __webpack_public_path__ + "static/media/blog_page.0169d0b2.jpg";